// Points react_ujs at an explicit component registry instead of the admin-wide
// `require.context` in server_rendering.js. The public packs (job_new, public)
// use this so a public page only downloads the components it can mount.
import buildRegistryContext from './registry_context';
// Patches dayjs.tz.guess before any component mounts, including MUI date pickers
// whose modules import dayjs directly (same as server_rendering.js). Registry
// loaders are lazy, so this still runs before any component module.
import '../components/NewUI/utils/dayjs.ts';

const ReactRailsUJS = require('react_ujs');

const installRegistry = (registry, packName) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks -- ReactRailsUJS API, not a React Hook.
  ReactRailsUJS.useContext(buildRegistryContext(registry, packName));
};

export default installRegistry;
